<template>
  <div>
    <base-nav v-model="showMenu" type="white" :transparent="true" menu-classes="justify-content-end" class="auth-navbar fixed-top">
      <div slot="brand" class="navbar-wrapper">
        <img src="https://raw.githubusercontent.com/cachac/webAssets/main/logos/jit-basic.png" alt="app-logo" width="20px" />
        <a v-if="title" class="navbar-brand" href="https://jit.cr/register" target="_blank">{{ title }}</a>
      </div>

      <ul class="navbar-nav">
        <!-- <nuxt-link class="nav-item" tag="li" to="/">
          <a class="nav-link text-primary"> <i class="tim-icons icon-minimal-left"></i> Back to Dashboard </a>
        </nuxt-link> -->
        <!-- <nuxt-link class="nav-item" tag="li" to="/register">
          <a class="nav-link"> <i class="tim-icons icon-laptop"></i> Register </a>
        </nuxt-link> -->

        <li v-if="page === 'register___en'" href="/" class="nav-link custom-link" @click="gotoLogin()"><i class="tim-icons icon-atom"></i> Login</li>

        <nuxt-link v-else class="nav-item custom-link" tag="li" to="/register">
          <li href="/register" class="nav-link"><i class="tim-icons icon-bulb-63"></i> Inicio</li>
        </nuxt-link>

        <!-- <nuxt-link class="nav-item" tag="li" to="/dashboard">
          <a class="nav-link"> <i class="tim-icons icon-single-02"></i> Mi Cuenta </a>
        </nuxt-link> -->

        <!-- TODO: pagina de about con info de contacto, equipo de trabajo y precios -->
        <!-- <nuxt-link class="nav-item" tag="li" to="/about">
          <a class="nav-link"> <i class="tim-icons icon-atom"></i> Nuestro Equipo </a>
        </nuxt-link> -->
      </ul>
    </base-nav>

    <div class="wrapper wrapper-full-page">
      <notifications></notifications>

      <div class="full-page" :class="pageClass">
        <div class="content">
          <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
            <nuxt></nuxt>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <div class="container-fluid">
            <div class="copyright">
              &copy; {{ year }}, Diseñado por
              <a class="mr-1" href="https://storylabs.dev" target="_blank">Story Labs CR</a>
              <svg
                class="mr-5"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="16px"
                height="16px"
                viewBox="0 0 48 48">
                <g transform="translate(0, 0)">
                  <path
                    fill="#B3B3B3"
                    d="M11.95508,23.2124c-0.26562,0-0.51953-0.10547-0.70703-0.29297l-6.85547-6.85547 c-0.32227-0.32227-0.38574-0.82227-0.1543-1.21484c0.75-1.27197,1.62891-2.41504,2.6123-3.39844 c4.95605-4.95605,12.31738-6.36621,18.75195-3.59424C25.90625,7.9873,26.125,8.25928,26.18848,8.5835 c0.06348,0.32373-0.03711,0.6582-0.26953,0.89355l-13.25195,13.4375c-0.18652,0.18994-0.44238,0.29688-0.70801,0.29785 C11.95703,23.2124,11.95605,23.2124,11.95508,23.2124z" />
                  <path
                    fill="#B3B3B3"
                    d="M32.64258,43.8999c-0.25879,0-0.51465-0.1001-0.70703-0.29297l-6.91602-6.91602 c-0.18848-0.18799-0.29395-0.44336-0.29297-0.70996c0.00098-0.26611,0.10742-0.521,0.29688-0.70801l13.44922-13.30322 c0.23438-0.23145,0.56738-0.33154,0.89062-0.27148c0.32324,0.06152,0.5957,0.27832,0.72754,0.57959 c2.84473,6.46729,1.4541,13.875-3.54199,18.87158c-0.98145,0.98193-2.125,1.86035-3.39844,2.61182 C32.99219,43.85449,32.81738,43.8999,32.64258,43.8999z" />
                  <path
                    fill="#E6E6E6"
                    d="M8.04395,27.34131c-0.14941,0.37207-0.0625,0.79688,0.2207,1.08008l11.31348,11.31348 c0.19141,0.19141,0.44727,0.29297,0.70703,0.29297c0.12793,0,0.25586-0.02441,0.37891-0.07422 c0.18848-0.07733,14.57507-6.15625,21.92511-21.36444L29.36237,5.36237C14.12976,12.69263,8.11975,27.1521,8.04395,27.34131z" />
                  <path
                    fill="#E86C60"
                    d="M46.4502,1.55273c-0.20117-0.20215-0.49414-0.31104-0.76074-0.29297 c-6.34113,0.33087-11.74622,1.89819-16.32709,4.1026l13.22681,13.22681c2.21027-4.5733,3.79181-9.96222,4.15009-16.27423 C46.75586,2.03125,46.65039,1.75439,46.4502,1.55273z" />
                  <path
                    fill="#76B5B5"
                    d="M27.35547,25.64062c-1.28027,0-2.56055-0.4873-3.53516-1.46191c-1.94922-1.94922-1.94922-5.12158,0-7.0708 l0,0c1.9502-1.95117,5.12305-1.94922,7.07129,0c0.94434,0.94434,1.46484,2.19971,1.46484,3.53516 c0,1.33594-0.52051,2.59131-1.46484,3.53564C29.91699,25.15332,28.63672,25.64062,27.35547,25.64062z" />
                  <path
                    fill="#EA9860"
                    d="M5.51074,45.05273c-0.73438,0-1.31543-0.03564-1.58496-0.05566 c-0.49414-0.03662-0.88672-0.4292-0.92285-0.92334c-0.07129-0.95557-0.33398-5.81396,1.46191-7.60938l0,0l0,0 C5.40918,35.52002,6.66406,35,8,35s2.59082,0.52002,3.53516,1.46436c1.94922,1.94971,1.94922,5.12158,0,7.07129 C10.24707,44.82422,7.37988,45.05273,5.51074,45.05273z" />
                </g>
              </svg>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { ZoomCenterTransition } from 'vue2-transitions'
import { BaseNav } from '@/components'

export default {
  components: {
    BaseNav,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page',
      onLine: null
    }
  },
  computed: {
    title() {
      return 'JIT: ERP - CRM - Inventarios'
    },
    page() {
      return this.$route.name
    }
  },
  beforeDestroy() {
    this.closeMenu()
  },
  methods: {
    closeMenu() {
      document.body.classList.remove('nav-open')
      this.showMenu = false
    },
    gotoLogin() {
      localStorage.setItem('sf-session-first', 'nuevo ingreso')
      console.log('goto😃')
      this.$router.push('/')
    }
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu()
      setTimeout(() => {
        next()
      }, this.menuTransitionDuration)
    } else {
      next()
    }
  }
}
</script>
<style lang="scss">
.back {
  z-index: 1 !important;
}
.navbar.auth-navbar {
  top: 0;
}

$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.custom-link {
  // color: white;
  font-size: 18px;
  cursor: pointer;
  font-weight: 500;
}
</style>
